import axios from "axios";
import api from "../api";
import { DocumentSignType, UserSigner } from "../context/hooks/useDocument";

export const createDocumentGat = async (documentFiles: File[], userId: string, nameDocument: string): Promise<any> => {
  const formData = new FormData();

  const file = base64ToFile(documentFiles[0], nameDocument, "application/pdf");

  formData.append('files', file);
  formData.append("userId", userId);

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  const formDataConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("token")?.replace(/"/g, "") || ""}`
    },
  };

  const result = await api.post(`/documents/upload?userId=${userId}`, formData, formDataConfig);

  if (result.status === 200) {
    return result.data;
  } else {
    throw new Error("Não foi possível cadastrar Documento");
  }
};

function base64ToBlob(base64: string, mimeType = 'application/octet-stream') {
  const byteCharacters = atob(base64.split(',')[1]); // Remove o prefixo "data:<mimeType>;base64,"
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
}

function base64ToFile(base64: any, fileName: string, mimeType = 'application/octet-stream') {
  const blob = base64ToBlob(base64, mimeType);
  return new File([blob], fileName, { type: mimeType });
}

export const createDocumentSignTypeGat = async (document: DocumentSignType): Promise<boolean> => {
  const result = await api.post(`/users/signers`, document);
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const resendEmailGat = async (data: any): Promise<boolean> => {
  const result = await api.post(`/users/signers/resend/mail`, data);
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const updateDocumentSignTypeGat = async (document: DocumentSignType): Promise<boolean> => {
  const result = await api.put(`/users/signers/edit`, document);
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const deleteDocumentSignTypeGat = async (idDocument: string): Promise<boolean> => {
  const result = await api.delete(`/documents?documentId=${idDocument}`);
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const createSignUserGat = async (signUser: UserSigner): Promise<boolean> => {
  const result = await api.put(`/users/sign`, signUser);
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const getDocumentSignGat = async (documentId: string): Promise<any> => {
  const result = await api.get(`/documents/download?documentId=${documentId}`);
  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível pegar o Documento");
  }
};

export const getSignersGat = async (documentId: string): Promise<any> => {
  const result = await api.get(`/users/signers?documentId=${documentId}`);
  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível pegar o Documento");
  }
};

export const getSignersEditGat = async (documentId: string): Promise<any> => {
  const result = await api.get(`/users/signers/edit?documentId=${documentId}`);
  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível pegar o Documento");
  }
};

export const getDocumentsGat = async (documentId: string, page: number, rowsPerPage: number, documentName?: string): Promise<any> => {


  let url = `/documents/?`;

  if (documentId) {
    url = url + `userId=${documentId}`;
  }

  if (page) {
    url = url + `&pageNumber=${page}`;
  }

  if (rowsPerPage) {
    url = url + `&pageSize=${rowsPerPage}`;
  }

  if (documentName) {
    url = url + `&documentName=${documentName}`;
  }

  const result = await api.get(url);

  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível pegar o Documento");
  }
};

export const downloadDocumentGat = async (documentId: string, finalVersion: boolean): Promise<void> => {
  try {
    const response = await api.get(
      `/documents/download/file?documentId=${documentId}&finalVersion=${finalVersion}`,
      {
        responseType: "blob", 
      }
    );

    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      link.download = finalVersion ? "assinado.pdf" : "original.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  } catch (error) {
    console.error("Erro ao fazer o download do documento:", error);
    throw new Error("Não foi possível baixar o documento.");
  }
};

interface DocumentsReportParams {
  pageNumber: number;
  pageSize: number;
  documentName?: string;
  ownerEmail?: string;
  signerEmail?: string;
  status?: number;
  createdFrom?: string;
  createdTo?: string;
}

export const getDocumentsReportGat = async (params: DocumentsReportParams): Promise<any> => {
  const {
    pageNumber,
    pageSize,
    documentName,
    ownerEmail,
    signerEmail,
    status,
    createdFrom,
    createdTo,
  } = params;

  const query = new URLSearchParams();
  query.append("pageNumber", String(pageNumber));
  query.append("pageSize", String(pageSize));

  if (documentName) query.append("documentName", documentName);
  if (ownerEmail) query.append("ownerEmail", ownerEmail);
  if (signerEmail) query.append("signerEmail", signerEmail);
  if (typeof status === "number") query.append("status", String(status));
  if (createdFrom) query.append("createdFrom", createdFrom);
  if (createdTo) query.append("createdTo", createdTo);

  const result = await api.get(`/documents/report?${query.toString()}`);

  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível carregar o relatório de documentos");
  }
};

interface DocumentsReportExportParams {
  documentName?: string;
  ownerEmail?: string;
  signerEmail?: string;
  status?: number;
  createdFrom?: string;
  createdTo?: string;
}

export interface SignerLinkItem {
  email: string;
  name: string;
  hasSigned: boolean;
  link: string | null;
  phone: string | null;
}

export const getSignerLinksGat = async (documentId: string): Promise<SignerLinkItem[]> => {
  const result = await api.get(`/users/signers/links?documentId=${documentId}`);
  if (result.status === 200) {
    return result.data.data.signers;
  } else {
    throw new Error("Não foi possível gerar os links dos signatários");
  }
};

export interface ResendSignerItem {
  email: string;
  name: string;
  encryptedToken: string;
  phone?: string | null;
  sendWhatsApp: boolean;
}

export interface ResendWithTokensData {
  documentEmailFromAddress: string;
  documentNameFromAddress: string;
  documentId: string;
  signers: ResendSignerItem[];
  emailMessageTitle: string;
  messageEmailBody?: string;
}

export const resendEmailWithTokensGat = async (data: ResendWithTokensData): Promise<boolean> => {
  const result = await api.post(`/users/signers/resend/with-tokens`, data);
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível reenviar os e-mails");
  }
};

export const getDocumentsReportExportGat = async (params: DocumentsReportExportParams): Promise<any> => {
  const { documentName, ownerEmail, signerEmail, status, createdFrom, createdTo } = params;
  const query = new URLSearchParams();
  if (documentName) query.append("documentName", documentName);
  if (ownerEmail) query.append("ownerEmail", ownerEmail);
  if (signerEmail) query.append("signerEmail", signerEmail);
  if (typeof status === "number") query.append("status", String(status));
  if (createdFrom) query.append("createdFrom", createdFrom);
  if (createdTo) query.append("createdTo", createdTo);
  const qs = query.toString();
  const result = await api.get(`/documents/report/export${qs ? `?${qs}` : ""}`);
  if (result.status === 200) return result;
  throw new Error("Não foi possível exportar o relatório");
};

// IA summary of document by external webhook
export const getDocumentSummaryGat = async (documentId: string): Promise<string> => {
  const result = await axios.post(
    "https://primary-production-1798.up.railway.app/webhook/search-file",
    { documentId }
  );

  if (result.status === 200) {
    // API returns { output: "..." }
    return result.data?.output ?? "";
  }

  throw new Error("Não foi possível gerar o resumo do documento");
};